export const LABELS = {
  NO_KEY: 'No recaptcha key provided',
  INIT_ERROR: 'Captcha failed to initialize',
};

export default LABELS;
